// src/app/App.tsx
import { Admin, Resource } from "react-admin";
import { authProvider } from "./authProvider";
import { dataProvider } from "./dataProvider";
import { theme } from "./theme";
import { Layout } from "./Layout";
import LoginPage from "./layout/LoginPage";
import { Dashboard } from "./components/Dashboard";
import { APP_TITLE } from "./config";

// Import resource components
import {
  PropertyList,
  PropertyEdit,
  PropertyShow,
} from "./resources/properties";
import { BookingList, BookingEdit, BookingShow } from "./resources/bookings";
import { UserList, UserEdit, UserCreate, UserShow } from "./resources/users";
import {
  ProviderList,
  ProviderEdit,
  ProviderShow,
  ProviderCreate,
} from "./resources/providers";
import {
  ReferralList,
  ReferralCreate,
  ReferralEdit,
  ReferralShow,
} from "./resources/referrals";
import {
  PromotionList,
  PromotionCreate,
  PromotionEdit,
  PromotionShow,
} from "./resources/promotions";

// Disable React Admin telemetry
if (typeof window !== "undefined") {
  (
    window as Window & { __REACT_ADMIN_TELEMETRY__?: boolean }
  ).__REACT_ADMIN_TELEMETRY__ = false;
}

export const App = () => {
  // Set document title
  if (typeof document !== "undefined") {
    document.title = APP_TITLE;
  }

  return (
    <Admin
      title={APP_TITLE}
      theme={theme}
      authProvider={authProvider}
      dataProvider={dataProvider}
      layout={Layout}
      loginPage={LoginPage}
      dashboard={Dashboard}
    >
      <Resource
        name="properties"
        list={PropertyList}
        edit={PropertyEdit}
        show={PropertyShow}
        recordRepresentation="name"
      />
      <Resource
        name="bookings"
        list={BookingList}
        edit={BookingEdit}
        show={BookingShow}
        recordRepresentation={(record) =>
          `${record.property?.name || "Property"} - ${record.user?.name || record.user?.username || "Customer"}`
        }
      />
      <Resource
        name="users"
        list={UserList}
        edit={UserEdit}
        create={UserCreate}
        show={UserShow}
        recordRepresentation="name"
      />
      <Resource
        name="providers"
        list={ProviderList}
        edit={ProviderEdit}
        create={ProviderCreate}
        show={ProviderShow}
        recordRepresentation="name"
      />
      <Resource
        name="referrals"
        list={ReferralList}
        create={ReferralCreate}
        edit={ReferralEdit}
        show={ReferralShow}
        recordRepresentation="code"
      />
      <Resource
        name="promotions"
        list={PromotionList}
        create={PromotionCreate}
        edit={PromotionEdit}
        show={PromotionShow}
        recordRepresentation="name"
      />
    </Admin>
  );
};
